module.exports = require('./lib/linkify');



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/index.js
// module id = 211
// module chunks = 1